module.exports = __webpack_public_path__ + "img/soapDetail.219a2b27.jpeg";